(function ($, Drupal, drupalSettings) {

	'use strict';

	Drupal.behaviors.mpRecipeSlider = {
	  attach: function (context, settings) {
		if (typeof settings.mp_paragraphs === 'undefined') return;
		for (var id in settings.mp_paragraphs.mp_recipe_slider) {
			var slider_settings = settings.mp_paragraphs.mp_recipe_slider[id],
			  $slider = $('#' + id + ' > .mp-recipe-slider__items', context),
			  $controls = $slider.siblings('.mp-recipe-slider__controls'),
			  $prevArrow = $controls.find('.mp-recipe-slider__prev'),
			  $nextArrow = $controls.find('.mp-recipe-slider__next')
		  ;

			$slider.addClass('slick-arrowed');

      $(once('slick', $slider, context)).slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        dots: false,
        arrows: true,
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });

		  // $slider.slick({
			// 	slidesToShow: 4,
			// 	slidesToScroll: 4,
			// 	infinite: false,
			// 	dots: false,
			// 	arrows: true,
			// 	prevArrow: $prevArrow,
			// 	nextArrow: $nextArrow,
			// 	responsive: [
			// 		{
			// 			breakpoint: 1200,
			// 			settings: {
			// 			slidesToShow: 2,
			// 			slidesToScroll: 2,
			// 			}
			// 		},
			// 		{
			// 			breakpoint: 768,
			// 			settings: {
			// 			slidesToShow: 1,
			// 			slidesToScroll: 1
			// 			}
			// 		}
			// 		// You can unslick at a given breakpoint now by adding:
			// 		// settings: "unslick"
			// 		// instead of a settings object
			// 	]
		  // });

		}
	  }
	};

  })(jQuery, Drupal, drupalSettings);
